import * as React from 'react';
import { io } from 'socket.io-client';
import PropTypes from 'prop-types';

import { useAuth } from './auth-context';

const SocketContext = React.createContext();

const resolveSocketUrl = () => {
  if (process.env.NODE_ENV !== 'development') {
    return '';
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:5000';
  }

  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:5000`;
};

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = React.useState(null);
  const { isAuthenticated, token } = useAuth();

  React.useEffect(() => {
    let socketIO = null;
    if (isAuthenticated && token) {
      socketIO = io(resolveSocketUrl(), {
        auth: {
          token: `Bearer ${token}`,
        },
      });
      setSocket(socketIO);
    }
    return () => {
      if (socketIO) {
        socketIO.disconnect();
        socketIO.off();
        setSocket(null);
      }
    };
  }, [isAuthenticated, token]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

const useSocket = () => {
  const context = React.useContext(SocketContext);
  if (context === undefined) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

SocketProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SocketProvider, useSocket };
